import { LogoMark } from "@/components/site/Logo";

export const RotatingBadge = () => (
  <div className="relative w-28 h-28 sm:w-32 sm:h-32 rounded-full bg-[#0D0D0F] border border-white/15 grid place-items-center">
    <svg viewBox="0 0 100 100" className="absolute inset-0 w-full h-full animate-[spin_16s_linear_infinite]" aria-hidden="true">
      <defs>
        <path id="badge-circle" d="M50,50 m-37,0 a37,37 0 1,1 74,0 a37,37 0 1,1 -74,0" />
      </defs>
      <text fill="#FFF4E8" fontSize="8.6" fontWeight="700" letterSpacing="1.6" fontFamily="DM Sans">
        <textPath href="#badge-circle">SEMPRE SUL FUOCO • MISTER POLLO •</textPath>
      </text>
    </svg>
    <LogoMark className="w-9 h-9" />
  </div>
);
